import type { TransactionCategory } from "../shared/types";

/** View model: API DTO binding is kept at the transaction page boundary. */
export interface TransactionEvidenceGuide {
  readonly categoryName: string;
  readonly recommendedDocumentNames: readonly string[];
  readonly alternativeEvidenceDescription: string;
  readonly minimumDocumentCount: number;
  readonly maximumDocumentCount: number;
  readonly documentTypeOptions: readonly { readonly code: string; readonly name: string }[];
}
export interface EvidenceSelection {
  readonly file: File;
  readonly documentTypeCode: string;
}
export function transactionEvidenceGuide(category?: TransactionCategory | null): TransactionEvidenceGuide | undefined {
  if (!category || category.documentSubmissionPolicy !== "ANY_EVIDENCE" || !Array.isArray(category.documentTypeOptions)
    || !Array.isArray(category.recommendedDocumentNames) || typeof category.alternativeEvidenceDescription !== "string"
    || !Number.isInteger(category.minimumDocumentCount) || !Number.isInteger(category.maximumDocumentCount)
    || category.minimumDocumentCount < 1 || category.maximumDocumentCount < category.minimumDocumentCount) return undefined;
  return {
    categoryName: category.name, recommendedDocumentNames: category.recommendedDocumentNames,
    alternativeEvidenceDescription: category.alternativeEvidenceDescription,
    minimumDocumentCount: category.minimumDocumentCount, maximumDocumentCount: category.maximumDocumentCount,
    documentTypeOptions: category.documentTypeOptions.map(option => ({ code: option.documentTypeCode, name: option.documentTypeName })),
  };
}
export function evidenceSelectionError(selection: readonly EvidenceSelection[], guide: TransactionEvidenceGuide): string | undefined {
  if (selection.length < guide.minimumDocumentCount) return `거래 내용을 확인할 증빙을 ${guide.minimumDocumentCount}개 이상 첨부해 주세요.`;
  if (selection.length > guide.maximumDocumentCount) return `증빙은 최대 ${guide.maximumDocumentCount}개까지 첨부할 수 있습니다.`;
  if (selection.some(item => !guide.documentTypeOptions.some(option => option.code === item.documentTypeCode))) return "첨부한 파일의 서류 종류를 확인해 주세요.";
  return undefined;
}
export function updateEvidenceFiles(selection: readonly EvidenceSelection[], files: readonly File[], guide: TransactionEvidenceGuide): readonly EvidenceSelection[] {
  const alternative = guide.documentTypeOptions.find(option => option.code === "ALTERNATIVE_EVIDENCE");
  return files.map(file => selection.find(item => item.file === file) ?? { file, documentTypeCode: alternative?.code ?? "" });
}
/** Changing category keeps actual classifications; unsupported selections need user correction. */
export function evidenceTypeName(code: string, guide: TransactionEvidenceGuide): string {
  return guide.documentTypeOptions.find(option => option.code === code)?.name ?? "종류 확인 필요";
}
